import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useAppDispatch } from 'hooks/reduxHooks'

import Leaderboard from 'components/Common/Banner/Leaderboard'
import { fetchBanners } from 'actions/ContentActions'
import { getPlacement } from 'lib/url/campaignUtils'
import { BANNER_LOCATION_HUB } from 'constants/bannerLocations'

interface Props extends App.HubPageComponentBannersLoader {
  banners: Array<App.Banner>;
}

function BannersLoader(props: Props) {
  const { banners } = props
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchBanners(BANNER_LOCATION_HUB, props.tags))
  }, [dispatch, props.tags])

  const topBanners = getPlacement(banners, 'top')

  if (!topBanners.length) {
    return null
  }

  return <Leaderboard banners={topBanners} />
}

function mapStateToProps(state: App.State) {
  return {
    banners: state.content.banners.hub,
  }
}

BannersLoader.defaultProps = {
  banners: [],
}

export default connect(mapStateToProps)(BannersLoader)
